import React, { useEffect, useState } from 'react';
import DataTable from '../common/DataTable';
import { numOfPage, PickListColumns } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';
import BatchPagination from '../batch/BatchPagination';
import { getPackingLabels } from '../../store/actions/picker.action';
import moment from 'moment';
import DatePickerComponent from "../common/DatePickerComponent";
import LoaderSpinner from '../common/Loader';
import _ from 'lodash';
import { toast } from "react-toastify";
import { getMergedPdf } from '../../store/actions/batch.action';
import { commaSeparatedStringToArray } from '../../config/utils';
import ViewOrderDialog from './ViewOrderDialog';

/*istanbul ignore next */
const PickList = () => {
    let dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [packingLabels, setPackingLabels] = useState([]);
    const [viewDetailDetails, setViewDetailDetails] = useState({
        show: false,
        item: {}
    });
    const { packingLabelListStatus, packingLabelList } = useSelector((state) => state.pickerReducer);

    let dataLoad = {
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'ASCENDING',
        searchkey: '',
        startDate: moment().format('YYYY-MM-DDT00:00:00'),
        endDate: moment().format('YYYY-MM-DDT00:00:00'),
    }
    const [filterData, setfilterData] = useState(dataLoad);

    const handleAction = async (item, type) => {
        if (type === 'print') {
            let data = commaSeparatedStringToArray(item.orderNumber);
            if (data.length) {
                let mergedRes = await getMergedPdf(data, true);
                if (mergedRes?.data?.Status === 200) {
                    window.open(mergedRes.data.Entity);
                    toast.success('Label printed successfully');
                    fetchAllList();
                }
            } else {
                toast.error('Can not reprint selected order(s) label');
            }
        } else if (type === 'view') {
            setViewDetailDetails({
                show: true,
                item: item
            });
        }
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    useEffect(() => {
        if (packingLabelListStatus === 'PENDING') {
            setLoader(true);
        } else if (packingLabelListStatus === 'SUCCESS') {
            setLoader(false);
        }
    }, [packingLabelListStatus]);

    useEffect(() => {
        fetchAllList();
    }, [filterData.numberOfPage, filterData.pageIndex, filterData.pageSize, filterData.sortColumn, filterData.sortOrder]);

    const fetchAllList = () => {
        let payload = {
            ...filterData,
            startDate: moment(filterData.startDate).format('YYYY-MM-DD'),
            endDate: moment(filterData.endDate).format('YYYY-MM-DD')
        };
        dispatch(getPackingLabels(payload));
    }

    const handleDateChange = (date) => {
        let dateFormat = moment(date).format('YYYY-MM-DDT00:00:00');
        let dataLoad = {
            ...filterData,
            startDate: dateFormat,
            endDate: dateFormat
        }
        setfilterData(dataLoad);
        let payload = {
            ...dataLoad,
            startDate: moment(date).format('YYYY-MM-DD'),
            endDate: moment(date).format('YYYY-MM-DD')
        }
        dispatch(getPackingLabels(payload));
    }

    useEffect(() => {
        if (packingLabelList?.packingLabelList) {
            let addlistIndex = packingLabelList.packingLabelList.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
            }));
            setPackingLabels(addlistIndex);
            if (packingLabelListStatus === 'SUCCESS') {
                setfilterData({
                    ...filterData,
                    totalPages: Math.ceil(packingLabelList?.TotalRecords / filterData.pageSize),
                });
            }
        }
    }, [packingLabelList]);

    const handleCheckRecord = (e, type) => {
        const { checked } = e.target;
        let recordData = [...packingLabels];
        if (_.isEmpty(type)) {
            if (checked) {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: true,
                }));
                setPackingLabels(markCheck);

            } else {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: false,
                }));
                setPackingLabels(markCheck);
            }
        } else {
            recordData[type.listIndex].isChecked = checked;
            setPackingLabels(recordData);
        }
    };

    const handleMultiPrint = async () => {
        let checkedData = packingLabels.filter((item) => {
            if (item?.isChecked) {
                return item;
            }
        });
        if (checkedData.length) {
            let orderNumbers = checkedData.map(item => item.orderNumber.split(','));
            orderNumbers = orderNumbers.flat();

            let mergedRes = await getMergedPdf(orderNumbers, true);
            if (mergedRes?.data?.Status === 200) {
                toast.success('Labels printed successfully');
                fetchAllList();
                window.open(mergedRes.data.Entity);
            }
        } else {
            toast.error('Can not reprint selected order(s) label');
        }
    }

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Order Packing Plan
                    <div className="pickHead mb-3 pl-3 pr-3 pt-3 zIndex2">
                        <div></div>
                        <div className="pickHead">
                            <div className="fontFix">
                                <DatePickerComponent
                                    dateField={filterData.startDate}
                                    handleDateChange={(date) => handleDateChange(date)}
                                    fieldName="ValidFrom"
                                    dateFormat="MM-dd-yyyy"
                                    showFutureDate={false}
                                />
                            </div>

                            <button disabled={!packingLabels.filter(item => item.isChecked).length} className="btn cus-seconday-bg-btn showHideFilter ml-2" onClick={handleMultiPrint}>
                                <i className="fa fa-print" aria-hidden="true"></i> Print
                            </button>
                        </div>
                    </div>
                </div>
                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
                <div className="main_content_table_history">
                    <div className="tableFixHead pl-2 zIndex1">
                        {packingLabelListStatus === 'SUCCESS' && (
                            <DataTable
                                headers={PickListColumns}
                                tableData={packingLabels}
                                actionType={5}
                                handleAction={handleAction}
                                handleSortingColumn={handleSortingColumn}
                                tableDataStatus={packingLabelListStatus}
                                filterData={filterData}
                                handleCheckRecord={handleCheckRecord}
                                icon="print"
                                isSelectAll={packingLabels?.filter(item => item.isChecked).length === packingLabels.length}
                            />
                        )}
                    </div>
                </div>
                <BatchPagination
                    gridData={packingLabels}
                    totalVisualRecords={packingLabels?.length}
                    numberOfPage={filterData.pageSize}
                    numOfPage={numOfPage}
                    loader={loader}
                    currentPage={filterData.pageIndex}
                    totalPages={filterData.totalPages}
                    totalRecords={packingLabelList?.TotalRecords || 0}
                    setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                    setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value })}
                />
            </div>
            {viewDetailDetails.show && (
                <ViewOrderDialog
                    modalClass="modalDeleteWrapper"
                    setModalShow={setViewDetailDetails}
                    modalShow={viewDetailDetails.show}
                    viewDetailDetails={viewDetailDetails}
                    filterData={filterData}
                    fetchAllList={fetchAllList}
                />
            )}
        </main>
    );
}

export default PickList;